// extracted by mini-css-extract-plugin
module.exports =  {"label":"VcyJZEDdLDDAP99e4NuY","alert":"qDb575BC9QiNIGM__6wi"};